import { useContext } from "react";
import { PoweredByAiFi } from "src/assets/icons/PoweredByAiFi";
import { MasterContext } from "src/lib/masterContext";
import styled from "styled-components";
import { ReferencePagesNavigation } from "../ReferencePagesNavigation";

export const Footer = () => {
  const {
    featureFlags: { hidePoweredByAiFi },
  } = useContext(MasterContext);

  return (
    <FooterSection>
      {!hidePoweredByAiFi && <PoweredByAiFi />}
      <ReferencePagesNavigation />
    </FooterSection>
  );
};

const FooterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  gap: 16px;
`;
